import { env } from '~/env';

export const ApiConfig = {
  // baseUrl: env.VITE_API_BASE_URL ?? 'https://data-api.styrkelyft.se',
  baseUrl: env.VITE_API_BASE_URL ?? 'https://ssfdev.duckdns.org',
};
